<app-multi-select-btn 
    [label]="'Zones'"
    [list]="zones"
    [selected]="selected"
    (onClosed)="closedEvent($event)">
</app-multi-select-btn>
